'use client';

import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { EntityProvider } from '@/context/EntityProvider';
import { SafeSearchParamsProvider } from '@/features/safeSearchParams/context/SafeSearchParamsProvider';
import getQueryClient from '@/utils/getQueryClient';

export default function Providers({ children }: { children: React.ReactNode }): React.ReactNode {
  const queryClient = getQueryClient();
  const isLocalDevelopment = process.env.NODE_ENV === 'development';

  return (
    <SafeSearchParamsProvider>
      <QueryClientProvider client={queryClient}>
        <EntityProvider>
          {children}
          {isLocalDevelopment ? <ReactQueryDevtools /> : null}
        </EntityProvider>
      </QueryClientProvider>
    </SafeSearchParamsProvider>
  );
}
